import React from "react";

import SignIn from "../../components/pages/SignIn";
import connector from "../../utils/reduxConnect/connector";

import {
  dispatchMapperArray,
  propMapperArray,
  tokenIdf,
} from "../../data/constants";
// import { useNavigation } from "../../hooks/useNavigation";
import { removeLocalItem } from "../../utils/localStorageUtils";

const pageIdentifier = "Authentication";

function Authentication({ signInSuccess, signOut }) {
  // const navigateTo = useNavigation();
  // const { instance, accounts } = useMsal();

  React.useEffect(() => {
    removeLocalItem(tokenIdf);
    signOut();

    // Check if user is already logged in with Azure
    // if (accounts.length > 0) {
    //   handleAzureLogin();
    // }
  }, [signOut]);

  // const handleAzureLogin = async () => {
  //   try {
  //     Notifications.activity("Authenticating with Microsoft...");

  //     // Get token silently if user is already logged in, otherwise do a popup login
  //     const tokenResponse =
  //       accounts.length > 0
  //         ? await instance.acquireTokenSilent({
  //             ...loginRequest,
  //             account: accounts[0],
  //           })
  //         : await instance.acquireTokenPopup(loginRequest);

  //     // Send token to backend for validation
  //     const { data, error } = await loginWithAzure(tokenResponse);

  //     if (!error) {
  //       setLocalItem(tokenIdf, JSON.stringify(data));
  //       signInSuccess(data);

  //       Notifications.success("Successfully signed in with Microsoft!");

  //       setTimeout(() => {
  //         navigateTo(routes.base);
  //       }, 800);
  //     } else {
  //       Notifications.error(data.message || "Azure authentication failed");
  //     }
  //   } catch (error) {
  //     console.error("Azure login error:", error);
  //     Notifications.error("Microsoft authentication failed. Please try again.");
  //   }
  // };

  const signIn = async (payload, setFetchingToken) => {
    // const { data, error } = await login(payload);
    // if (!error) {
    //   setLocalItem(tokenIdf, JSON.stringify(data));
    //   signInSuccess(data);
    //   Notifications.success("Successfully signed in!");
    //   setTimeout(() => {
    //     setFetchingToken(false);
    //     navigateTo(routes.base);
    //   }, 800);
    // } else {
    //   Notifications.error(data.message);
    //   setFetchingToken(false);
    // }
  };

  return <SignIn signIn={signIn} />;
}

export default connector(
  propMapperArray[pageIdentifier],
  dispatchMapperArray[pageIdentifier]
)(Authentication);
